import { useState, useCallback } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { useSidebarStore } from '@/store/sidebarStore';
import { useAuthStore } from '@/store/authStore';
import { useInactivityLogout } from '@/hooks/useInactivityLogout';
import { InactivityLogoutModal } from '@/components/InactivityLogoutModal';
import { cn } from '@/utils/cn';

export function AdminLayout() {
  const collapsed = useSidebarStore((s) => s.collapsed);
  const logout = useAuthStore((s) => s.logout);
  const navigate = useNavigate();
  const [warnOpen, setWarnOpen] = useState(false);

  const handleLogout = useCallback(() => {
    setWarnOpen(false);
    logout();
    navigate('/login');
  }, [logout, navigate]);

  const { reset: resetIdle } = useInactivityLogout({
    onWarn: () => setWarnOpen(true),
    onExpire: handleLogout,
  });

  const handleStay = useCallback(() => {
    setWarnOpen(false);
    resetIdle();
  }, [resetIdle]);

  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <main
        className={cn(
          'flex-1 transition-all duration-300',
          // Desktop margin for fixed sidebar
          'lg:ml-[260px]',
          collapsed && 'lg:ml-[72px]',
          // Mobile: no margin (sidebar is overlay)
          'ml-0',
        )}
      >
        <Outlet />
      </main>

      <InactivityLogoutModal
        open={warnOpen}
        onStay={handleStay}
        onLogout={handleLogout}
      />
    </div>
  );
}
